import { BellOutlined, EyeOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Switch, Tooltip } from 'antd';
import React from 'react';

export interface INotificationFilterSwitchProps {
  onChange: (value: boolean) => void;
  defaultChecked: boolean;
}

export function NotificationFilterSwitch(
  props: INotificationFilterSwitchProps,
) {
  const { onChange, defaultChecked } = props;
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        defaultChecked
          ? t('notification-filter-switch.to-read', 'Da Leggere')
          : t('notification-filter-switch.all', 'Tutte')
      }
    >
      <Switch
        aria-label={`Filtra notifiche: ${
          !defaultChecked ? 'Mostra da leggere' : 'Mostra tutte'
        }`}
        checkedChildren={<BellOutlined aria-hidden />}
        unCheckedChildren={<EyeOutlined aria-hidden />}
        onChange={onChange}
        defaultChecked={defaultChecked}
      />
    </Tooltip>
  );
}
